import UserLibrary from "../../services/user-library";

export const groupsBuddiesActionNames = {
  SET_USER_PROFILE_FLAG: "SET_USER_PROFILE_FLAG",
  SET_BUDDY_PROFILE_FLAG: "SET_BUDDY_PROFILE_FLAG",
  SET_PROFILE_PICTURE: "SET_PROFILE_PICTURE",
  SET_DISPLAYNAME: "SET_OTHER_DISPLAYNAME",
  SET_LAST_ACTIVE_TIME: "SET_LAST_ACTIVE_TIME",
  SET_STUDY_TIME: "SET_STUDY_TIME",
  SET_DESCRIPTION: "SET_DESCRIPTION",
  SET_PRIVACY: "SET_PRIVACY",
  SET_MEMBERS: "SET_MEMBERS",
  SET_MEMBER_FLAG: "SET_MEMBER_FLAG",
  SET_GROUP_FLAG: "SET_GROUP_FLAG",
};

const setUserData = (user) => {
  return (dispatch) => {
    dispatch({
      type: groupsBuddiesActionNames.SET_PROFILE_PICTURE,
      payload: user.userPreferences.profilePicture,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_DISPLAYNAME,
      payload: user.userPreferences.displayName,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_LAST_ACTIVE_TIME,
      payload: user.studyData.lastActiveTime,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_STUDY_TIME,
      payload: user.studyData.studyTime,
    });
  };
};

const setGroupData = (group) => {
  return (dispatch) => {
    dispatch({
      type: groupsBuddiesActionNames.SET_MEMBER_FLAG,
      payload: group.isMember,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_PROFILE_PICTURE,
      payload: group.userPreferences.profilePicture,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_DISPLAYNAME,
      payload: group.userPreferences.displayName,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_DESCRIPTION,
      payload: group.userPreferences.description,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_PRIVACY,
      payload: group.userPreferences.privacy,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_MEMBERS,
      payload: group.userPreferences.members,
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_STUDY_TIME,
      payload: group.studyData.studyTime,
    });
  };
};

export const isBuddy = (input) => {
  return async (dispatch) => {
    const userLibrary = new UserLibrary();
    const response = await userLibrary.getBuddy(input).catch((err) => {
      return false;
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_BUDDY_PROFILE_FLAG,
      payload: response,
    });
  };
};

export const isUser = (input) => {
  return async (dispatch) => {
    const userLibrary = new UserLibrary();
    const response = await userLibrary.getUser(input).catch((err) => {
      return false;
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_USER_PROFILE_FLAG,
      payload: Boolean(response),
    });
    if (response) {
      dispatch(setUserData(response));
    }
  };
};

export const isGroup = (input) => {
  return async (dispatch) => {
    const userLibrary = new UserLibrary();
    const response = await userLibrary.getGroups(input).catch((err) => {
      return false;
    });
    dispatch({
      type: groupsBuddiesActionNames.SET_GROUP_FLAG,
      payload: Boolean(response),
    });
    if (response) {
      dispatch(setGroupData(response));
    }
  };
};
